import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import { Roles } from "../enums/Roles";
import { useCallback } from "react";
import Cookies from "js-cookie";

export default function AdminGuard() {
  const { token, loggedUser } = useAuth();

  const logout = useCallback(() => {
    Cookies.remove(window.__env.AUTH_TOKEN_NAME || "get-move-token");
    Cookies.remove(window.__env.AUTH_USER_NAME || "get-move-user");
  }, []);

  if (!token || (loggedUser && loggedUser.role !== Roles.Superadmin)) {
    logout();
    return <Navigate to="/login" />;
  }
  return <Outlet />;
}
